import constants from "Constants";
import axios from "axios";

axios.defaults.baseURL = constants.apiUrl;
axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
